<script>
import ContextMenu from './ContextMenu.vue';
import Stages from './Stages.vue';

export default {
  components: {
    ContextMenu,
    Stages,
  },
  props: {
    workflow: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['deleteStage', 'editStage', 'addStage', 'edit', 'delete'],
};
</script>

<template>
  <div>
    <div class="pointer-events-auto mt-9">
      <div class="workflow-node-item flex items-center gap-2">
        <span class="text-heading-3 text-n-slate-12 truncate flex-1">{{
          workflow.name
        }}</span>
        <ContextMenu @edit="$emit('edit')" @delete="$emit('delete')" />
      </div>
    </div>
    <Stages
      :workflow="workflow"
      @add-stage="$emit('addStage')"
      @edit-stage="stage => $emit('editStage', stage)"
      @delete-stage="stage => $emit('deleteStage', stage)"
    />
  </div>
</template>

<style scoped lang="scss">
.workflow-node-item {
  @apply rounded-xl shadow-sm outline outline-1 -outline-offset-1 outline-n-weak bg-n-solid-2;
  @apply min-w-[16rem] flex-grow py-3 px-4;
}
</style>
